import { Outlet } from 'react-router'

import { StepMark } from '@/components/StepMark'
import { AppSidebar } from '@/components/layout/AppSidebar'
import { CommandK } from '@/components/layout/CommandK'
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar'

export function AppShell() {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="flex h-svh flex-col overflow-hidden">
        {/*
          Below 768px the sidebar collapses into a sheet that only opens from a
          SidebarTrigger. Only the Knowledge and AI shells rendered one, so on a
          phone every other route (inbox, contacts, reports, settings…) lost the
          navigation entirely with no way to get it back. This bar gives every
          route a trigger; the per-feature ones stay for desktop collapsing.
        */}
        <div className="flex items-center gap-2 border-b px-3 py-2 md:hidden">
          <SidebarTrigger />
          {/* size-5, not size-4: the mark's master geometry closes up below
              20px (that is what assets/brand/stept-favicon.svg exists for). */}
          <StepMark className="size-5" />
          <span className="text-sm font-semibold tracking-tight">Stept</span>
        </div>
        <div className="min-h-0 flex-1">
          <Outlet />
        </div>
      </SidebarInset>
      <CommandK />
    </SidebarProvider>
  )
}
